export default class BigDecimal {
    // Configuration: constants
    static DECIMALS = 10; // number of decimals on all instances
    static ROUNDED = true; // numbers are truncated (false) or rounded (true)
    static SHIFT = BigInt('1' + '0'.repeat(BigDecimal.DECIMALS)); // derived constant
    constructor(value) {
        if (value instanceof BigDecimal) return value;
        let [ints, decis] = String(value)
            .split('.')
            .concat('');
        this._n = BigInt(ints + decis.padEnd(BigDecimal.DECIMALS, '0')
                .slice(0, BigDecimal.DECIMALS)) + BigInt(BigDecimal.ROUNDED && decis[BigDecimal.DECIMALS] >= '5');
    }
    static fromBigInt(bigint) {
        return Object.assign(Object.create(BigDecimal.prototype), { _n: bigint });
    }
    static floor(num) {
        let number = BigDecimal.fromBigInt(num._n);
        const decimalPointIndex = number
            .toString()
            .split('')
            .findIndex(char => char === '.');

        const floorPart = Math.floor(+number.toString().slice(decimalPointIndex - 1));
        return new BigDecimal(number.toString().slice(0, decimalPointIndex - 1) + floorPart);
    }
    add(num) {
        return BigDecimal.fromBigInt(this._n + new BigDecimal(num)._n);
    }
    subtract(num) {
        return BigDecimal.fromBigInt(this._n - new BigDecimal(num)._n);
    }
    static _divRound(dividend, divisor) {
        return BigDecimal.fromBigInt(dividend / divisor + (BigDecimal.ROUNDED ? ((dividend * 2n) / divisor) % 2n : 0n));
    }
    multiply(num) {
        return BigDecimal._divRound(this._n * new BigDecimal(num)._n, BigDecimal.SHIFT);
    }
    divide(num) {
        return BigDecimal._divRound(this._n * BigDecimal.SHIFT, new BigDecimal(num)._n);
    }
    toFixed(precision) {
        const decimalPointIndex = this.toString()
            .split('')
            .findIndex(char => char === '.');

        const roundedPart = (+this.toString().slice(decimalPointIndex - 1)).toFixed(precision);
        return this.toString().slice(0, decimalPointIndex - 1) + roundedPart;
    }
    isFractional() {
        return !!this.toString()
            .split('')
            .find(char => char === '.');
    }
    isNegative() {
        return !!this.toString()
            .split('')
            .find(char => char === '-');
    }
    isZero() {
        return this._n === 0n;
    }
    pow(power) {
        if (power === 0) {
            return new BigDecimal('1');
        }
        const multiplier = BigDecimal.fromBigInt(this._n);
        let result = multiplier;
        for (let i = 1; i < power; i++) {
            result = result.multiply(multiplier);
        }
        return result;
    }
    toString() {
        const s = this._n.toString().padStart(BigDecimal.DECIMALS + 1, '0');

        return s.slice(0, -BigDecimal.DECIMALS) + ('.' + s.slice(-BigDecimal.DECIMALS)).replace(/\.?0+$/, '');
    }
}
